
<div >
    <c-rep-order-hum
        v-model   = "showHumOrderDialog"
        :incident = "incident"
        :data     = "data.order.hum"
    />

    <c-rep-order-ruv
        v-model   = "showRuvOrderDialog"
        :incident = "incident"
        :data     = "data.order.hum"
    />

    <v-menu
        close-on-click
        offset-x
        nudge-left="-10"
        nudge-top="10"
        v-model="printOpen"
        min-width="300"
        :close-on-content-click="false"
    >
        <template v-slot:activator="{ on: menu, attrs }">
            <v-tooltip bottom>
                <template v-slot:activator="{ on: tooltip }">
                    <v-btn
                        small
                        fab
                        v-bind="attrs"
                        v-on="{ ...tooltip, ...menu }"
                    >
                        <v-icon color="primary">mdi-printer</v-icon>
                    </v-btn>
                </template>
                <span>Dokumente drucken</span>
            </v-tooltip>
        </template>
        <c-column-header label="Dokument drucken" class="primary" title-border>
            <template v-slot:pre>
                <div style="min-width: 18px"></div>
            </template>
        </c-column-header>
        <v-list>
            <v-list-item link @click="onPrint(100)" v-if="!isMaintanace">
                <v-list-item-title>
                    Rechnungsprüfungsdeckblatt
                </v-list-item-title>
            </v-list-item>
            <v-list-item link @click="onHumOrderDialog" v-if="isHum && !isMaintanace">
                <v-list-item-title>
                    H&M Auftrag
                </v-list-item-title>
            </v-list-item>
            <v-list-item link @click="onRuvOrderDialog" v-if="isRuv && !isMaintanace">
                <v-list-item-title>
                    R+V Auftrag
                </v-list-item-title>
            </v-list-item>
        </v-list>
    </v-menu>
</div>
